// Plain module (no "use client") so the string is inlined verbatim
// into the SSR head. Runs before hydration to avoid a black-to-light
// flash on load for users with the light preference stored.
export const THEME_STORAGE_KEY = "fc-admin-theme";

export const THEME_BOOTSTRAP_SCRIPT = `
  try {
    var t = localStorage.getItem('${THEME_STORAGE_KEY}');
    if (t !== 'light' && t !== 'dark') {
      t = window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
    }
    document.documentElement.setAttribute('data-theme', t);
    document.documentElement.style.colorScheme = t;
  } catch (_) {}
`;
